(function() {
    let obj;
    window.tlIsHandleAddingGift = false;
    const handleClickAdd = async(ruleId) => {
        if(window.tlIsHandleAddingGift) return;
        window.tlIsHandleAddingGift = true;
        const allBtn = document.querySelectorAll("label.salepify-fg-advanced__gift-quantity");
        const currentText = allBtn[0].innerHTML;
        try{
            allBtn.forEach(ele => {
                ele.setAttribute('disabled', '')
                ele.classList.add("salepify-fg-loading");
                ele.innerHTML = '<div class="button-loader"></div>';
            })
            await window.tlAdvancedFreeGift.handleAddGiftAndReload(ruleId)
        }catch(error){
            console.log(`Salepify custom - Error when handleClickAdd: `, error)
        }finally {
            allBtn.forEach(ele => {
                ele.removeAttribute('disabled')
                ele.classList.remove("salepify-fg-loading");
                ele.innerHTML = currentText;
            })
            window.tlIsHandleAddingGift = false;
        }
    }

    Object.defineProperty(window, "tlAdvancedFreeGift", {
        get() {
            return obj;
        },
        set(val) {
            
            if (val && typeof val.handleChangCheckBox === "function" && !obj) {
                val.handleChangCheckBox =  function (evt, ruleId, giftId) {
                    const ruleData = window.tlAdvancedFreeGift.ruleIdMapData.get(ruleId);
                    if (!ruleData ) return;
                    const claimableTimes = window.tlAdvancedFreeGift.ruleIdMapCanClaimTime.get(ruleId) ?? 1;

                    const { is_gift_qty_fixed: isGiftQtyFixed, gift_qty: giftQty, total_gift_line_items: totalGiftLineItems, listChilds } = ruleData;
                    let quantity = giftQty * claimableTimes;
                    if(isGiftQtyFixed){
                        const addingGift = listChilds.filter(child => child.shopify_id == giftId )
                        quantity = addingGift.quantity * claimableTimes
                    }

                    window.tlAdvancedFreeGift.ruleIdMapSelectedGift.set(ruleId, {
                        [giftId]: quantity
                    })

                    handleClickAdd(ruleId)
                };
                obj = val;
            }

        },
        configurable: true
    });
})();
 
 